import api from 'lib/trpcClient';

const useInvestmentUpload = () => {
  const validate =
    api.investorInvestmentUpload.validateAndPreview.useMutation();
  const identityLookup =
    api.investorInvestmentUpload.lookupIdentity.useMutation();

  return {
    validate,
    identityLookup,
  };
};

export default useInvestmentUpload;
